<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-file-manager"
        :class="{ 'show': isShowSidebar }"
      >
        <div class="sidebar-inner">
          <!-- sidebar menu links starts -->
          <!-- add category button -->
          <div class="add-file-btn p-1">
            <b-button
              class="btn btn-primary text-center w-100"
              variant="primary"
              @click="addCategory"
            >
              <feather-icon icon="PlusCircleIcon" />
              <span class="align-middle ml-1">Thêm thư mục</span>
            </b-button>
          </div>
          <!-- add file button ends -->

          <!-- sidebar list items starts  -->
          <vue-perfect-scrollbar class="sidebar-list scroll-area">
            <!-- links for file manager sidebar -->
            <CategoryTree />

            <div
              v-if="showRecentFilter"
              class="list-group list-group-labels"
            >
              <h6 class="section-label px-2 mb-1">
                Phân Loại
              </h6>
              <a
                href="#"
                class="list-group-item list-group-item-action active"
              >
                <feather-icon icon="StarIcon" />
                <span class="align-middle ml-1">Đã xuất bản</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="ClockIcon" />
                <span class="align-middle ml-1">Gần đây</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-1">Đã xóa</span>
              </a>
            </div>

            <div
              v-if="showTypeFilter"
              class="list-group list-group-labels"
            >
              <h6 class="section-label px-2 mb-1">
                Loại
              </h6>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-1">Tài liệu</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="ImageIcon" />
                <span class="align-middle ml-1">Ảnh</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="VideoIcon" />
                <span class="align-middle ml-1">Video</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="MusicIcon" />
                <span class="align-middle ml-1">Audio</span>
              </a>
              <a
                href="#"
                class="list-group-item list-group-item-action"
              >
                <feather-icon icon="ArchiveIcon" />
                <span class="align-middle ml-1">Lưu trữ</span>
              </a>
            </div>
            <!-- links for file manager sidebar ends -->

            <!-- storage status of file manager starts-->
            <div
              v-if="showStorage"
              class="storage-status mb-1 px-2"
            >
              <h6 class="section-label mb-1">
                Trạng thái lưu trữ
              </h6>
              <div class="d-flex align-items-center cursor-pointer">
                <i
                  data-feather="server"
                  class="font-large-1"
                />
                <div class="file-manager-progress ms-1">
                  <span>68GB đã dùng của 100TB</span>
                  <div
                    class="progress progress-bar-primary my-50"
                    style="height: 6px"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="80"
                      aria-valuemax="100"
                      style="width: 80%"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- storage status of file manager ends-->
          </vue-perfect-scrollbar>
          <!-- side bar list items ends  -->
          <!-- sidebar menu links ends -->
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { showToast } from '@/@core/utils/utils';
import CategoryTree from './CategoryTree.vue';

export default {
  components: {
    BButton,
    VuePerfectScrollbar,
    CategoryTree,
  },
  data() {
    return {
      showRecentFilter: false,
      showTypeFilter: false,
      showStorage: false,
    }
  },
  computed: {
    isSelectedCategory() {
      return this.$store.state.files.selected_category;
    },
    isShowSidebar() {
      return this.$store.state.files.show_sidebar;
    },
  },
  methods: {
    addCategory() {
      if (this.isSelectedCategory === null || this.isSelectedCategory === undefined) {
        showToast('Chưa chọn thư mục');
      } else if (!this.isSelectedCategory.allow_create_sub) {
        showToast('Thư mục này không cho phép tạo thư mục con');
      } else {
        this.$store.dispatch('files/showCategoryForm', (new Date()).getTime());
      }
    },
    editCategory() {
      if (!this.isSelectedCategory.allow_delete) {
        showToast('Thư mục này không được phép sửa');
      } else {
        this.$store.dispatch('files/showCategoryForm', (new Date()).getTime());
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
